<template>
  <!--  ************ HOME AMILON **********  -->
  <!-- Mostra l'insieme dei fornitori Amilon -->
  <div>
    <PageTagline :elements="tagline_elem" />

    <!-- Overlay di caricamento -->
    <CustomOverlay :show="overlay_show" text="Caricamento in corso, attendere...">

      <!--CARD PRINCIPALE DI CONTENIMENTO DELLA HOME -->
      <b-card title="Buoni - Voucher" sub-title="Scegli tra tanti grandi marchi">
        <b-row class='mt-3'>
          <b-col>
            <p class="alert-message p-2"><b>ATTENZIONE!</b> Esplora attentamente tutte le possibilità di scelta offerte dalla sezione "buoni", ma ricorda che una volta inviata la richiesta d'acquisto di un prodotto/buono specifico, essa non potrà essere annullata.</p>
          </b-col>
        </b-row>
        <!-- ELENCO DEI FORNITORI -->
        <b-row class="mt-3" v-for="( row_elem, index ) in parted_forn" :key="index" >
            <b-col class="text-center" v-for="( col_elem, index ) in row_elem" :key="index" :cols="calculate_bootstrap_col_class(parted_forn)">
              <b-link @click="visualizza_vetrina(col_elem.RetailerId)">
                <div class="mt-3 forn-badge">
                  <!-- Per porre il logo non usiamo un tag image ma un div dove poniamo il logo -->
                  <!-- come sfondo centrato. In questo modo è più facile gestire immagini dei loghi -->
                  <!-- che non hanno dimensioni uniformi come quelle che ci fornisce Amilon. -->
                  <!-- L'url del logo lo passiamo al css con la variabile css background-image-url. -->
                  <div class="logo-container" :style="{ '--background-image-url' : 'url(\'' + col_elem.ImageUrl + '\')' }"></div>
                  <h6 class="mt-4 font-italic">{{col_elem.Name}}</h6>
                </div>
              </b-link>
            </b-col>
        </b-row>
      </b-card>
    </CustomOverlay>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import CustomOverlay from '@/components/CustomOverlay'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'HomeAmilon',
  data () {
    return {
      // Variabili generali
      tagline_elem : [ { text : "Buoni - Voucher", link : 'conv-aml' } ],
      overlay_show: false,

      // Array dei fornitori
      fornitori : []
    }
  },
  computed : {
    /**
     * Ripartisce i fornitori in un'array di array di modo tale da avere
     * forn_by_row elementi per ogni sotto array e cioè forn_by_row elementi
     * per ogni riga.
     */
    parted_forn : function () {
      return generalLib.sub_array_partition( this.fornitori, this.forn_by_row );
    }
  },
  methods : {
    /**
     * Wrapper per la funzione di libreria omonima, senza il wrapper non potrei
     * richiamarla direttamente dal template.
     * Data un'array partizionata calcola la giusta classe boostrap da dare alle
     * colonne per spaziare adeguatamente il contenuto.
     */
    calculate_bootstrap_col_class : function ( parted_array ) {
      return generalLib.calculate_bootstrap_col_class( parted_array );
    },
    /**
     * Al click sull'immagine del fornitore visualizza la vetrina dello stesso.
     */
    visualizza_vetrina : function ( forn_id ) {
      this.$router.push( { name : 'forn-aml', params : { id_fornitore : forn_id } } );
    }
  },
  /**
   * Carichiamo i fornitori dei prodotti Amilon al caricamento della pagina
   */
  created : function () {

    this.overlay_show = true;

    // La chiamata usa la paginazione ma a noi non interessa al momento
    // quindi prendiamo in blocco tutti i fornitori.
    axios.get( apiUrl.amilonapi.get_retailers )
    .then( ( response ) => {

      this.fornitori = response.data.results;
      this.overlay_show = false;

    })
    .catch( ( error ) => {
        this.overlay_show = false;
        let message = "Si è verificato un errore nel caricamento delle informazioni, " +
                      "si prega di riprovare, se il problema persiste contattare l'assistenza";
        generalLib.backend_error_message_box( this, message );
        console.error( error.response.data );
    });
  },
  props : {
    /**
     * Numero massimo di fornitori da visualizzare per ogni riga
     */
    forn_by_row: {
      type: Number,
      default: 4,
      validator: function (value) {
        // Non possiamo ospitare più di 12 elementi per riga.
        // Cioè le 12 colonne consentite da bootstrap.
        return value <= 12;
      }
    }
  },
  components: {
    PageTagline,
    CustomOverlay
  }

}
</script>

<style scoped>
/* Css dei badge per mostrare i fonitori */
.forn-badge {
  display: inline-block;
  border : 1px solid rgba(0,0,0,.125);
  border-radius: 10px;
  padding: 10px 10px 20px 10px;
  text-decoration: none;
  color: #000000;
  width: 400px;
}

.logo-container{
  /* Impostiamo l'altezza del contanitore del logo a 200px fissi
     ma la larghezza la imponiamo pari al 100% dell'elemento che lo
     contiene, cioè il div forn-badge, di modo tale che poi questo
     elemento riesce a regolarsi bene in relazione ai cambi di dimensione
     del forn-badge con le varie media query impostate sotto */
  width: 100%;
  height: 200px;
  /* background-image-url è la variaible css impostata sopra dal template
     e che qui usiamo per impostare il logo del produttore come sfondo centrato */
  background-image: var( --background-image-url )!important;
  background: no-repeat center;
}

.forn-badge:hover .logo-container{
  filter: blur(1px);
}

.forn-badge:hover {
  background: #ebebeb;
  color: #636363;
}

/* Sistemiamo la larghezza dei badge a seconda del wiewport, essendo i loghi più
   piccoli delle immagini delel categorie ( 200x200px ) dobbiamo settarle a mano
   per avere la grandezza voluta.*/
@media (max-width: 576px) {
  .forn-badge{
    width: 100%;
  }
}
@media (min-width: 768px) {
  .forn-badge{
    width: 80%;
  }
}
@media (min-width: 992px) {
  .forn-badge{
    width: 100%;
  }
}

.alert-message{
  color: #721c24;
  background-color: #f8d7da;
}
</style>